import { FC } from "react";
import {
  InformationBox,
  MuiButtonPrimary,
  MuiGrid,
} from "../../../../components";
import PermissionWrapper from "../../../../components/permissionWrapper/PermissionWrapper";
import { MODULE_PERMISSIONS, PAGE_IDS } from "../../../../helpers/constants";
import { useSiteCore } from "../../../../hooks/useSiteCore";
import { MdmActivitySearchHeaderWrapper } from "../../../mdmActivitySearch/components/mdmActivitySearchHeader/MdmActivitySearchHeader.style";
import { mdmOfficeHeaderSiteCoreKeys } from "../../../mdmCreateOffice/siteCore/SiteCoreKeys";

interface ActivitySearchHeaderProps {
  onCreateOffice: () => void;
}

export const MdmOfficeSearchHeader: FC<ActivitySearchHeaderProps> = ({
  onCreateOffice,
}) => {
  const pageId = PAGE_IDS.MDM_OFFICE_SEARCH_HEADER;
  const { pageTitle, fetchLabel } = useSiteCore();

  return (
    <MdmActivitySearchHeaderWrapper>
      <MuiGrid container>
        <MuiGrid size={{ sm: 6, xs: 12 }} className="header-left">
          <InformationBox title={pageTitle} />
        </MuiGrid>
        <PermissionWrapper permission={MODULE_PERMISSIONS.ADD_MDM_OFFICE}>
          <MuiGrid size={{ sm: 6, xs: 12 }} className="header-right">
            <MuiButtonPrimary
              onClick={onCreateOffice}
              className="header-right-button"
              id={`${pageId}-new-button`}
              data-testid={`${pageId}-new-button`}
            >
              {fetchLabel(
                mdmOfficeHeaderSiteCoreKeys.officeHeaderTitle,
                mdmOfficeHeaderSiteCoreKeys.createNewOfficeButton,
              )}
            </MuiButtonPrimary>
          </MuiGrid>
        </PermissionWrapper>
      </MuiGrid>
    </MdmActivitySearchHeaderWrapper>
  );
};
